import {GeometryType} from '../enums/geometry-type.enum';
import {BasePoint} from './base-point';
import {SpotIcon} from '../enums/spot-icon.enum';
import {GeometryConverter} from '../utils/geometry-converter';
import {CommonUtil} from '../../common/utils/common.util';

export class Spot extends BasePoint {
  iconId = 0;
  iconColor = '#888888';
  groupId = '';

  constructor(
    id: string
  ) {
    super(id, GeometryType.TYPE_SPOT);
  }

  getIconUrl(ignoreSelected: boolean = false) {
    // if(this.selected && !ignoreSelected && this.iconId < 1000) {
    //   return `/assets/icons/ic_spot_delete.png`;
    // }
    return `/assets/icons/spot/${this.iconId}.svg`;
    // if(this.iconId >= 1000){
    // }
    // const name = Object.keys(SpotIcon)[this.iconId];
    // return `/assets/icons/ic_spot_${this.selected && !ignoreSelected ? 'delete' : name}.png`;
  }

  setIcon(iconId: number) {
    this.iconId = iconId;
  }

  updateLabel(position?: google.maps.LatLngLiteral, createIcon: boolean = false) {
    super.updateLabel(position);
    this.label.text = this.name;
  }

  update() {
    this.updateLabel();
  }

  toFirebaseData(deep?: boolean): any {
    return GeometryConverter.spotToData(this);
  }

  load(data: any) {
    GeometryConverter.loadDataToSpot(this, data);
  }

}
